import { Shirt, Sparkles, Loader2 } from "lucide-react";
import type { GeneratedImage } from "./types";
import { GradientButton } from "./GradientButton";

type ImageCardProps = {
  image: GeneratedImage;
  index: number;
  selectedOrientation: string;
  onSelectImage: (imageUrl: string) => void;
  onStartEditing: (index: number) => void;
  selectingImageUrl: string | null;
  isMobile?: boolean;
};

export const ImageCard = ({
  image,
  index,
  selectedOrientation,
  onSelectImage,
  onStartEditing,
  selectingImageUrl,
  isMobile = false
}: ImageCardProps) => {
  const isSelecting = selectingImageUrl === image.url;
  const isDisabled = selectingImageUrl !== null;

  const getAspectRatio = () => {
    if (selectedOrientation === "landscape") return "16/9";
    if (selectedOrientation === "portrait") return "9/16";
    return "1/1";
  };

  return (
    <div className="group relative overflow-hidden rounded-xl border border-gray-200 bg-white shadow-lg transition-all duration-300 hover:shadow-xl">
      <div
        className={`bg-gray-100 ${isMobile ? "p-6" : "p-8"}`}
        style={{
          aspectRatio: getAspectRatio()
        }}
      >
        <div className="flex h-full w-full items-center justify-center overflow-hidden rounded-lg bg-white shadow-sm">
          <img src={image.url} className="h-full w-full object-contain" />
        </div>
      </div>

      <div className={`${isMobile ? "p-3" : "p-4"} border-t border-gray-100`}>
        <div className="mb-2">
          <button
            data-testid="select-image-button"
            onClick={() => onSelectImage(image.url)}
            disabled={isDisabled}
            className={`w-full rounded-sm bg-indigo-600 px-4 py-2 font-medium text-white transition-colors hover:bg-indigo-700 disabled:bg-gray-300 disabled:text-gray-400 ${isMobile ? "text-sm" : "text-base"} relative mb-4 flex items-center justify-center gap-2`}
            style={isDisabled ? {} : { color: "white" }}
          >
            {isSelecting && (
              <div className="absolute inset-0 flex items-center justify-center rounded-sm bg-indigo-600">
                <Loader2 className="h-4 w-4 animate-spin text-white" />
              </div>
            )}
            <Shirt className="h-4 w-4" />
            Choose This
          </button>
        </div>

        <GradientButton
          onClick={() => onStartEditing(index)}
          disabled={isDisabled}
          className="w-full"
          style={isDisabled ? {} : { color: "white" }}
          data-testid="refine-design-button"
        >
          <Sparkles className="h-4 w-4" />
          Refine Design
        </GradientButton>
      </div>
    </div>
  );
};
